/* eslint import/prefer-default-export: "off" */
import type {
  IdentityQueryResp_IdentityCountEntry,
  IdentitySummaryInfo
} from '@src/endpoints/services/graphQueryMgr.service'
import { ResourceTypeEnum } from '@src/endpoints/services/commonHdr.service'
import type { AccountInfo } from '@src/endpoints/services/base.service'
import type {
  IdentitySummaryItem,
  UserLocationItem
} from '@src/redux/reducers/identities/default.state'
import { getAccountNameById } from './accounts'
import type { UserLocationData } from '@src/endpoints/services/usagemanager.service'

export function formatIdentitySummaryInfo(
  item: IdentitySummaryInfo,
  account_info: AccountInfo[]
): IdentitySummaryItem {
  return {
    ...item,
    account_name: getAccountNameById(item.account_id, account_info),
    scopes: item.scope_cnt | 0
  }
}

export const getIdentitiesTotals = (
  identity_count: IdentityQueryResp_IdentityCountEntry
) => ({
  [ResourceTypeEnum.USER]: identity_count[ResourceTypeEnum.USER],
  [ResourceTypeEnum.GROUP]: identity_count[ResourceTypeEnum.GROUP],
  [ResourceTypeEnum.ROLE]: identity_count[ResourceTypeEnum.ROLE],
  [ResourceTypeEnum.SERVICE_ACCOUNT]:
    identity_count[ResourceTypeEnum.SERVICE_ACCOUNT],
  [ResourceTypeEnum.FEDERATED_USER]:
    identity_count[ResourceTypeEnum.FEDERATED_USER],
  [ResourceTypeEnum.FEDERATED_GROUP]:
    identity_count[ResourceTypeEnum.FEDERATED_GROUP],
  ...identity_count
})

export function formatUserLocations(
  locations: UserLocationData
): UserLocationItem[] {
  if (
    !locations ||
    !locations.locationdata ||
    locations.locationdata.length <= 0
  )
    return []

  const data = locations?.locationdata || []
  const userLocations: UserLocationItem[] = []
  for (let i = 0; i < data.length; i++) {
    if (!data[i]?.coordinates?.longitude || !data[i]?.coordinates?.latitude)
      continue

    userLocations.push({
      name: [data[i]?.city, data[i]?.state, data[i]?.country]
        .filter(x => x)
        .join(', '),
      coordinates: [
        data[i]?.coordinates?.longitude,
        data[i]?.coordinates?.latitude
      ],
      radius: data[i]?.radius || 1
    })
  }
  return userLocations
}
